import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedReorder202512: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_reorder_202512",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-12-01",
  endDate: "2025-12-31",
  impressions: 4979,
  clicks: 72,
  adsSpendDollars: 91,
  budgetDollars: 600,
  salesDollars: 448,
  bestEstimateRoas: 4.92,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.15,
  reorderConversions: 3,
  dataAvailableAtDate: "2026-01-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
